module.exports = __webpack_public_path__ + "static/home2-banner-sizes-4e121c453df2b35b0cd0cf5821f75bf0.png";